var e=/\w*$/;function r(r){var t=new r.constructor(r.source,e.exec(r));return t.lastIndex=r.lastIndex,t}export{r as default};
//# sourceMappingURL=_cloneRegExp.js.map
